
import { Component, Prop, Vue } from 'vue-property-decorator';
import Icon from '@/components/UI/Icon.vue';
import { fetchJobUnlock, fetchSetJobEditAsFutile, fetchSetJobLock } from '@/helpers/fetchers';
import { JobComplianceData } from '@/models/JobComplianceTypes';
import { JobLockError, ValidationAPIError } from '@/helpers/throwables';
import { notifyNetworkError } from '@/helpers/notifiers';

@Component({
  components: {
    Icon,
  },
})
export default class JobCloseAsFutile extends Vue {
  @Prop({ type: Number, required: true, default: 0 }) private driver: number;
  @Prop({ type: Object, required: false, default: false }) public formData: JobComplianceData;

  public loading = false;
  public futile_reason = '';

  public async setJobAsFutileClicked(): Promise<void> {
    const form = this.$refs.formFutile as HTMLFormElement;
    if (form) {
      const success = await form.validate();
      if (success) {
        this.loading = true;

        await fetchSetJobLock(this.formData.rockhopper_id, this.formData.rockhopper_date)
          .then(async () => {
            const params: { [key: string]: string } = {
              reason: this.futile_reason,
            };
            await fetchSetJobEditAsFutile(this.formData.rockhopper_id, this.formData.rockhopper_date, params)
              .then(() => {
                this.futile_reason = '';
                this.$emit('fetchData');
              })
              .catch(err => {
                // In case of validation error, unlock the job
                if (err instanceof ValidationAPIError) {
                  notifyNetworkError({ text: err.message });
                }
              })
              .finally(async () => {
                await fetchJobUnlock(this.formData.rockhopper_id, this.formData.rockhopper_date);
              });
          })
          .catch(err => {
            if (err instanceof JobLockError) {
              return;
            }
          });

        this.loading = false;
      }
    }
  }
}
